// UI và layout constants
export const PAGE_SIZE = 18
export const PAGE_SIZE_ACCOUNT = 10
export const MAX_FILE_SIZE = 1 * 1024 * 1024
export const UPLOAD_LIMIT = 2 * 1024 * 1024

// Image paths
export const URL_IMG = '/assets/images/'
export const URL_DECOR = '/assets/decor/'
export const URL_ICON = '/assets/icons/'
export const URL_ICON_BASE = '/assets/icon-base/'

export const USER_PLACEHOLDER = URL_IMG + 'user-default.png'
// Placeholder images
export const IMG_PLACEHOLDER = '/assets/images/default-thumbnail.png'
export const IMG_PLACEHOLDER_SQUARE = '/assets/images/default_thumbnail_square.png'
export const IMG_PLACEHOLDER_4_3 = '/assets/images/default_thumbnail_4_3.png'
export const IMG_PLACEHOLDER_VERTICLE = '/assets/images/default-vertical.png'
